<div class="grid">
  <p-toast></p-toast>
  <div class="col-12">
    <div class="card">
      <p-toast></p-toast>
      <div class="card">
        <h5>BUSCAR INTERFACES</h5>
        <div class="grid p-fluid">
          <div class="col-12 md:col-5">
            <p-dropdown [options]="listaInterfaceArquivos" placeholder="Lista de interfaces"
              optionLabel="nomeArquivoExcel" [(ngModel)]="filtroInterface.interfaceArquivo"
              [showClear]="true"></p-dropdown>
          </div>
          <div class="col-12 md:col-3">
            <p-dropdown [options]="tipoDeMovimento" placeholder="Tipos de movimento" optionLabel="nome"
              [(ngModel)]="filtroInterface.tipoMovimento" [showClear]="true"></p-dropdown>
          </div>
          <div class="col-12 md:col-3">
            <p-dropdown [options]="situcacaoDeProcessamento" placeholder="Situação do processamento" optionLabel="nome"
              [(ngModel)]="filtroInterface.situacaoProcessamento" [showClear]="true"></p-dropdown>
          </div>
          <div class="col-12 md:col-3">
            <p-calendar placeholder="Data Inicio" dateFormat="dd/mm/yy" [showIcon]="true"
              [(ngModel)]="filtroInterface.dataInicio" inputId="inputDataInicio"></p-calendar>
          </div>
          <div class="col-12 md:col-3">
            <p-calendar placeholder="Data Término" dateFormat="dd/mm/yy" [showIcon]="true"
              [(ngModel)]="filtroInterface.dataTermino" inputId="inputDataTermino"></p-calendar>
          </div>
        </div>
        <div class="my-2">
          <button pButton pRipple label="Buscar" icon="pi pi-search" (click)="buscarInterfacesAms(true)"
            class="p-button-info mr-2"></button>
          <button pButton pRipple label="Limpar" icon="pi pi-times" (click)="limparFiltro()"
            class="p-button-warning mr-2"></button>
        </div>
      </div>
      <p-table [value]="listaInterfaceAms" [columns]="cols" dataKey="id" [rows]="10"  sortField="dataGeracao"
        [sortOrder]="-1" [lazy]="true" (onLazyLoad)="buscarInterfacesAmsPorPagina($event)" [loading]="submitted"
        [totalRecords]="totalRegistrosGridPrincipal" [paginator]="true" [rowsPerPageOptions]="[10,20,30,50,100]"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{{ 'default.showing' | translate }} {first} {{ 'default.to' | translate }} {last} {{ 'default.of' | translate }} {totalRecords} {{ 'default.entries' | translate }}">

        <ng-template pTemplate="caption">
          <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 class="m-0">INTERFACES</h5>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>

            <th style="width: 140px; cursor:pointer; " (click)="ordenarListaInterfaceAms(true)" >Data de geração
              <i class={{icon}}></i>
            </th>

            <th style="width: 15px" class="text-left">Tipo de movimento</th>

            <th style="width: 140px" class="text-left">Nome interface</th>

            <th style="width: 15px" class="text-left">Versão</th>

            <th style="width: 15px" class="text-left">Registros</th>

            <th style="width: 15px" class="text-left">Registros incluídos</th>

            <th style="width: 15px" class="text-left">Registros alterados</th>
            <th style="width: 15px" pSortableColumn="quantidadeRegistrosExcluidos">Registros excluídos
            </th>
            <th style="width: 15px" class="text-left" pSortableColumn="quantidadeErros">Erros
            </th>
            <th style="width: 170px" class="text-left">Ações</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-interface>
          <tr>
            <td style="width:auto;" (click)="abrirInterfaceErroDetalhesDialog(interface)"><span
                class="p-column-title">Data geração</span>
              {{retornDataGeracao(interface.dataInclusao)}}
            </td>
            <td (click)="abrirInterfaceErroDetalhesDialog(interface)">
              <span class="p-column-title">Tipo de movimento</span>
              {{retornaTipoMovimento(interface.status)}}
            </td>
            <td (click)="abrirInterfaceErroDetalhesDialog(interface)">
              <span class="p-column-title">Nome interface</span>
              {{interface.siglaTabela}}
            </td>
            <td (click)="abrirInterfaceErroDetalhesDialog(interface)">
              <span class="p-column-title">Versão</span>
              {{ interface.numeroVersao }}
            </td>
            <td (click)="abrirInterfaceErroDetalhesDialog(interface)">
              <span class="p-column-title">Registros</span>
              {{ interface.qtdeRegistros }}
            </td>

            <td (click)="abrirInterfaceErroDetalhesDialog(interface)">
              <span class="p-column-title">Registros incluídos</span>
              {{interface.qtdeIncluidos}}
            </td>
            <td class="tdcustom" (click)="abrirInterfaceErroDetalhesDialog(interface)">
              <span class="p-column-title">Registros alterados</span>
              {{interface.qtdeAlterados}}
            </td>
            <td (click)="abrirInterfaceErroDetalhesDialog(interface)">
              <span class="p-column-title">Registros excluídos</span>
              {{interface.qtdeExcluidos}}
            </td>
            <td (click)="abrirInterfaceErroDetalhesDialog(interface)">
              <span class="p-column-title">Erros</span>
              {{interface.qtdeErros}}
            </td>
            <td>
              <span class="p-column-title">Ações</span>
              <div *ngIf="interface.qtdeErros > 0">
                <p-splitButton label="Ações" [model]="items"
                  (onDropdownClick)="handleEvent($event,interface.id,interface.nomeArquivo)"
                  styleClass="p-button-outlined p-button-secondary mr-2 mb-2">
                </p-splitButton>
              </div>
              <div *ngIf="interface.qtdeErros == 0">
                <p-splitButton label="Ações" [model]="itemArquivo"
                  (onDropdownClick)="handleEvent($event,interface.id,interface.nomeArquivo)"
                  styleClass="p-button-outlined p-button-secondary mr-2 mb-2">
                </p-splitButton>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <!-- Dialog Erros Detalhes Interface -->
    <p-dialog [(visible)]="interfaceErroDetalhesDialog" [style]="{width: '95%',height: 'auto'}" header="DETALHE DO ERRO"
      [modal]="true" class="p-fluid" position="center">
      <section>
        <div class="flex justify-content-between">
          <div class="flex justify-content-start">
            <div class="my-2 col-12 md:col-12">
              <b>Nome Arquivo:</b> {{interfaceAmsSelecionada !== null ?
              interfaceAmsSelecionada.nomeArquivo : ''}}
            </div>
          </div>
          <div styleClass="mb-4">
            <div class="my-2 col:12 md:col-2">
              <button type="button" pButton pRipple icon="pi pi-file-excel" class="p-button-success mr-2"
                (click)="exportarExcel()" pTooltip="XLS" tooltipPosition="bottom"></button>
            </div>
          </div>
        </div>
      </section>
      <p-table [value]="listaInterfaceAmsDetalhes" [columns]="colsErros" dataKey="id" [rows]="10" [lazy]="true"
        (onLazyLoad)="buscarDetalhesInterfacesAmsPorPagina($event)" [loading]="submitted" responsiveLayout="scroll"
        [totalRecords]="totalRegistrosGridDetalhes" [paginator]="true" [rowsPerPageOptions]="[10,20,30,50,100]"
        currentPageReportTemplate="{{ 'default.showing' | translate }} {first} {{ 'default.to' | translate }} {last} {{ 'default.of' | translate }} {totalRecords} {{ 'default.entries' | translate }}"
        [showCurrentPageReport]="true">
        <ng-template pTemplate="header">
          <tr>
            <th>
              <div class="flex justify-content-between align-items-center">
                Número linha
              </div>
            </th>
            <th>
              <div class="flex justify-content-between align-items-center">
                Nome campo
              </div>
            </th>
            <th>
              <div class="flex justify-content-between align-items-center">
                Informação campo
              </div>
            </th>
            <th>
              <div class="flex justify-content-between align-items-center">
                Descrição Erro
              </div>
            </th>
            <th>
              <div class="flex justify-content-between align-items-center">
                Data geração interface
              </div>
            </th>
            <th>
              <div class="flex justify-content-between align-items-center">
                Código empresa
              </div>
            </th>
            <th>
              <div class="flex justify-content-between align-items-center">
                Número matrícula
              </div>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-interfaceErro>
          <tr>
            <td style="min-width: auto;">
              {{interfaceErro.numeroLinha}}
            </td>
            <td style="min-width: auto;">
              {{interfaceErro.nomeCampo}}
            </td>
            <td style="min-width: auto;">
              {{interfaceErro.infoCampo }}
            </td>
            <td style="min-width: auto;">
              {{interfaceErro.descricaoErro }}
            </td>
            <td style="min-width: auto;">
              {{interfaceErro.dataInclusao | date:'short'}}
            </td>
            <td style="min-width: auto;">
              {{interfaceErro.codigoEmpresa}}
            </td>
            <td style="min-width: auto;">
              {{interfaceErro.numeroMatricula}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-dialog>
    <!-- Dialog Regularização Ocorrencia -->
    <p-dialog [(visible)]="interfaceTratativaOcorrencia" [style]="{width: '95%',height: 'auto'}"
              header="REGULARIZAÇÃO DE OCORRÊNCIA" [modal]="true" class="p-fluid" position="center">
      <section>
        <div class="flex justify-content-between">
          <div class="flex justify-content-start">
          </div>
        </div>
        <p-table [value]="listaOcorrencia" [columns]="colsErros" dataKey="id" [rows]="10" [lazy]="true">
          <ng-template pTemplate="header">
            <tr>
              <th>
                <div class="flex">
                  Descrição do erro
                </div>
              </th>
              <th>
                <div class="text-center">
                  Quantidade
                </div>
              </th>
              <th>
                <div class="flex">
                  Situação
                </div>
              </th>
              <th>
                <div class="text-center">
                  Histórico
                </div>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-ocorrencia>
            <tr>
              <td>
                {{ocorrencia.descricao}}
              </td>
              <td class="text-center">
                {{ocorrencia.quantidade}}
              </td>
              <td style="min-width: auto;">
                <input type="text" class="p-inputtext" disabled="true" [ngModel]="ocorrencia.situacao">
              </td>
              <td class="text-center">
                <button pButton pRipple type="button" icon="pi pi-pencil"
                  (click)="OcorrenciaInterfaceHistorico(ocorrencia.id)"
                  class="p-button-rounded p-button-success p-button-outlined text-center"></button>
              </td>
            </tr>
          </ng-template>

        </p-table>

      </section>

    </p-dialog>
  </div>
  <p-dialog [(visible)]="interfaceRegularizacaoOcorrenciaHistorico" [modal]="true"
            [style]="{width: '95%',height: 'auto'}"
            header="REGULARIZAÇÃO DE OCORRÊNCIA HISTÓRICO">
    <section>

      <div class="field">
        <label for="lblNomeArquivo" class="block">Nome Arquivo</label>
        <input id="lblNomeArquivo" type="text" pInputText class=" p-inputgroup" disabled="true" style="width: 300px"
          [ngModel]="nomeArquivoSelecionado">

        <label for="lblid" class="block">ID Ocorrencia</label>
        <input id="lblid" type="text" pInputText class="p-inputgroup" [ngModel]="idOcorrenciaSelecionda"
          style="width: 300px" disabled="true">
      </div>
      <div>
        <label for="txtDetalheSotuacao" class="block">Detalhe Situação</label>
        <textarea id="txtDetalheSotuacao" rows="5" cols="90" [(ngModel)]="situacaoHistorico.decricaoErro"></textarea>
      </div>
      <div class="field">
        <label for="lblsit" class="block">Situação</label>
        <p-dropdown id="lblsit" [options]="situacaoRegularizacao" optionLabel="nome"
          [(ngModel)]="situacaoHistorico.situacao" [showClear]="true">
        </p-dropdown>
      </div>

      <div class="field">
        <button type="button" pButton pRipple class=" p-button-success  mr-2" tooltipPosition="bottom"
          (click)="salvarOcorrenciaHistorico()" [disabled]="situacaoHistorico.situacao.code == 0 ||
                 situacaoHistorico.decricaoErro === null ||
                  situacaoHistorico.decricaoErro.length < 5 ">Incluir
        </button>

      </div>

    </section>
    <section>
      <p-table [value]="listaHistoricoGrid" [columns]="colsErros" dataKey="id" [rows]="10">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 25px">
              Detalhe da Situação
            </th>
            <th style="width: 10px" class="text-center">
              Usuário
            </th>
            <th style="width: 10px" class="text-center">
              Data/Hora
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-lista>
          <tr>
            <td style="width: 450px">
              {{lista.descricao}}
            </td>
            <td class="text-center" style="width: 60px">
              {{lista.usuarioResponsavel}}
            </td>
            <td class="text-center" style="width: 50px">
              {{lista.dataHoraUltimaAlteracao | date:'dd/MM/yyyy'}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </section>
  </p-dialog>
  <p-dialog [(visible)]="interfaceOcorrenciaNaocadastrada" [modal]="true" [style]="{width: '40%',height: '35%'}"
    header="ATENÇÃO">

    <ng-template pTemplate="content">
      <div class="flex ">
        <input class="inputtextocorrencia" type="text" placeholder="NENHUMA TRATATIVA ENCONTRADA PARA ESTA INTERFACE.">
      </div>
      <div class="flex ">
        <input class="inputtextocorrencia" type="text" placeholder="DESEJA CADASTRAR OCORRÊNCIA(S)?">
      </div>
    </ng-template>
    <ng-template pTemplate="footer">

      <div>
        <button type="button" pButton pRipple class=" p-button-success p-button-text mr-2" tooltipPosition="bottom"
          (click)="OcorrenciaInterfaces()">Sim
        </button>

        <button type="button" pButton pRipple class="p-button-danger p-button-text mr-2"
          (click)="interfaceOcorrenciaNaocadastrada = false" tooltipPosition="bottom">Não
        </button>
      </div>
    </ng-template>

  </p-dialog>

  <p-dialog [(visible)]="interfaceListaOcorrenciaCadastradaDB2" [modal]="true" [style]="{width: '65%',height: 'auto'}"
            header="Salvar Ocorrência">

    <section>

      <div>
        <p-table [value]="listaOcorrenciaDb2Grid">
          <ng-template pTemplate="header">
            <tr>

              <th>Nome Ocorrência</th>
              <th>Qtde Erros</th>

            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-listaDb2>
            <tr>
              <td>{{listaDb2.descricaoErro}}</td>
              <td>{{listaDb2.quantidade}}</td>
            </tr>
          </ng-template>

        </p-table>

      </div>
    </section>

    <ng-template pTemplate="footer">
      <div>
        <button type="button" pButton pRipple class=" p-button-success p-button-text mr-2" tooltipPosition="bottom"
          (click)="salvarOcorrencia(listaOcorrenciaDb2Grid)">Incluir
        </button>

        <button type="button" pButton pRipple class="p-button-danger p-button-text mr-2"
          (click)="interfaceListaOcorrenciaCadastradaDB2 = false" tooltipPosition="bottom">Cancelar
        </button>
      </div>
    </ng-template>

  </p-dialog>

</div>


<!-- Componente Spin-->
<div>
  <div style="margin: auto; text-align: center;">
    <p-dialog [closable]="false" [closeOnEscape]="false" [modal]="true" [(visible)]="submitted"
      [style]="{width: '300px'}">
      <div>
        <p-progressSpinner [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner" strokeWidth="10"
          fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
      </div>
    </p-dialog>
  </div>
</div>